<template>
  <v-container class="py-10">
    <v-row class="align-center">
      <v-col cols="12" lg="6" class="pr-10">
        <h2>14. Nutzen Zukunftstechnologien</h2>
        <p>
          Hinweis: Ich weiß nicht, ob wir hierfür überhaupt eine Grafik
          brauchen, da eigentlich soll nur eine Zahl dargestellt werden.
        </p>
      </v-col>
      <v-col cols="12" lg="6">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "UseFutureTech",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "item"
        },

        title: {
          text: "Nutzung von Zukunftstechnologien (in %)"
        },

        legend: {
          labelFormat: '{name} <span style="opacity: 0.4">{y} %</span>'
        },

        series: [
          {
            name: "Representatives",
            keys: ["name", "y", "color", "label"],
            layout: "horizontal",
            data: [
              [
                "Nutzen Zukunftstechnologien",
                34,
                "#7d9b38",
                "Nutzen Zukunftstechnologien"
              ],
              [
                "Nutzen keine Zukunftstechnologien",
                66,
                "#444",
                "Nutzen keine Zukunftstechnologien"
              ]
            ],
            dataLabels: {
              enabled: true,
              format: "{point.label} %"
            }
          }
        ]
      };
    }
  },
  methods: {
    downloadJPEG() {
      this.$refs.chart.chart.exportChart({ type: "image/jpeg" });
    },
    downloadSVG() {
      this.$refs.chart.chart.exportChart({ type: "image/svg+xml" });
    },
    downloadPDF() {
      this.$refs.chart.chart.exportChart({ type: "application/pdf" });
    },
    downloadCSV() {
      this.$refs.chart.chart.downloadCSV();
    }
  }
};
</script>
